const des_bloquear_a_numeracao_do_diario_de_classe = {
  path: "/des-bloquear-a-numeracao-do-diario-de-classe",
  redirect: "/des-bloquear-a-numeracao-do-diario-de-classe",
  meta: {
    breadCrumb: "Processo de Matrículas - Diário de Classe da Turma",
  },
  children: [
    {
      path: "/des-bloquear-a-numeracao-do-diario-de-classe",
      name: "des_bloquear_a_numeracao_do_diario_de_classe",
      component: () =>
        import(
          "@/views/DesBloquearANumeracaoDoDiarioDeClasse/DesBloquearANumeracaoDoDiarioDeClasse.vue"
        ),
    },
  ],
};

export { des_bloquear_a_numeracao_do_diario_de_classe };
